module.exports = "<div class=\"sr-only\" i18n>Loading Content</div>\n<div class=\"parent\">\n  <img src=\"assets/spinner.gif\">\n</div>\n"